module.exports = __webpack_public_path__ + "img/device002.bac063a8.png";